export function formatTokenId(tokenId: string) {
  return `#${tokenId}`;
}

export function formatSwooshHandle(swooshHandle: string) {
  return `${swooshHandle}.swoosh`;
}
